// *********** HOME ***************************************
// *** p_home.jsx ***********
// *** autor: W de Paula / MVinfo
// *** data: 08/08/24 | 12h50
// *** alterações: 27/8/24 | 12h29
// *** alterações: 16/9/24 | 16h24 | resolvido o problema do logout automática indevido em useEffect (indEmpresa e/ou emailValidado)
// *** alterações: 20/9/24 | 12h34 | acrescentado botão tipoAtendimento com texto ("Sem Colaborador" ou "Com Colaborador(es)"), apenas informativo
// *** alterações: 20/9/24 | 15h39 | correção do bug de .tipoatendimento para .tipoAtendimento na inicialização da variável
// *** alterações: 28/10/24 | 11h47 | acrescentado notificações de mudanças para o usuário;
// *** alterações: 08/11/24 | 19h55 | acrescentado "novidades" na aplicação para que o prestador possa interagir;
// *** alterações: 30/12/24 | 13h20 | eliminamos o localStorage.clear e individualizamos as remoções
// ***********************************************************





import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import Swal from "sweetalert2";
// import withReactContent from 'sweetalert2-react-content'; // acrescetando 28/10/24w pra mostrar 
import apiaxios from "../../../../Services/apiaxios.js";
import handleApiError from '../../../../Services/apiErrorHandler.js';
import { encrypt, decrypt } from "../../../../Services/cryptoUtils.js";
import { p_getUserData } from "../../../../Services/p_userutils.js";
import { useCarregaDados } from "../../Hooks/usecarregadados.jsx";
import { AutoLogout } from "../../../../Services/autologout.js";
import { Container, Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente

import Menu from "../../Components/Menu/p_menu.jsx";
import MenuConfig from "../../Components/Menu/p_menuconfig.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './p_home.css';

// Adicione estas constantes no início do componente
const ULTIMA_NOVIDADE_ID = 20; // Atualize sempre que adicionar nova novidade
const CHAVE_ULTIMA_NOVIDADE_VISTA = 'ultimaNovidadeVista';

// const MySwalNovidades = withReactContent(Swal);
// Exemplo de dados de novidades
const novidades = [
    { id: 21, titulo: 'Correções',              subtitulo: '27-10-25: melhoria na segurança dos dados...', descricao:  'Como exigência da LGPD, melhoramos a criptografia dos dados validados do prestador em todas as telas.' },
    { id: 20, titulo: 'Melhorias',              subtitulo: '17-10-25: Experiência do usuário...', descricao:  'As novidades que são exibidas na tela principal da aplicação, agora tem um visual mais moderno e opções mais claras para que o usuário decida exibir ou não cada uma delas .' },
    { id: 19, titulo: 'Novidade',               subtitulo: '17-10-25: Observação do serviço...', descricao:  'A partir de agora observações que o cliente faz no agendamento via link, são exibidas no menu agendamentos (em aberto, concluídos, excluídos, pendentes).' },
    { id: 18, titulo: 'Correções',              subtitulo: '17-10-25: Descrição do serviço...', descricao:  'A descrição do serviço não estava sendo exibida. Corrigida a falha.' },
    { id: 17, titulo: 'Melhorias',              subtitulo: '04-10-25: Confirmação do agendamento via link...', descricao:  'A partir desta versão, o cliente poderá ter uma melhor experiência ao "Concluir um agendamento". As informações estão mais claras, nítidas e com um visual espetacular.' },
    { id: 16, titulo: 'Melhorias',              subtitulo: '02-10-25: Melhorado o Reset de senha...', descricao:  'A partir desta versão, a tela de "Reset de senha", conta com mais uma opção, além das 2 que já existia (cliente, prestador e colaborador).' },
    { id: 15, titulo: 'Correções',              subtitulo: '25-09-25: Reset da senha funcionando...', descricao:  'Foi detectada a falha no reset da senha e foi corrigido. Agora o colaborador pode criar sua senha, por meio do "alterar senha".' },
    { id: 14, titulo: 'Melhorias',              subtitulo: '25-12-24: Acrescentada a foto no Serviço...', descricao:  'Agora no "Agendex Prestador Web" já é possível ser mostrada a foto do serviço por parte do prestador. Este serviço ainda não está disponível para o "consumidor final", o que estará em breve!' },
    { id: 13, titulo: 'Correções',              subtitulo: '09-12-24: Quantidade de "Intervalo Atendimento"...', descricao:  'O "intervalo de Atendimento" estava gerando erro se no servidor não tivesse sido ainda cadastrado.' },
    { id: 12, titulo: 'Melhorias',              subtitulo: '06-12-24: Quantidade de dias que faltam...', descricao:  'Agora é exibida a mensagem da quantidade de dias que faltam para vencer o quantro, quando estiver faltando 5 dias ou menos.' },
    { id: 11, titulo: 'Correções',              subtitulo: '30-11-24: Descrição foi reintegrada aos agendamentos...', descricao:  'A descrição "nome do serviço" foi equivocadamente removida em versões anteriores. Nesta versão voltamos esta informação.' },
    { id: 10, titulo: 'Novidade',               subtitulo: '22-11-24: 3 Novas opções liberadas no botão "Opções"...', descricao: 'No menu "Agendamentos Abertos", o botão "Opções" possui 4 novas funcionalidades liberadas: "excluir" agendamento, "mudar status", "reenviar confirmação" de agendamento e "gerar recibo" em PDF para enviar para o cliente.' },
    { id: 9, titulo: 'Melhorias',               subtitulo: '15-11-24: Novo botão "Opções" em Agendamentos...', descricao: 'No menu "Agendamentos Abertos", substituímos o botão "excluir" pelo botão "opções" que agora o prestador pode realizar diversas ações, como: "mudar status", "excluir agendamento", etc, dentre outras ações que estarão em breve disponíveis.' },
    { id: 8, titulo: 'Melhorias',               subtitulo: '14-11-24: Prestador que trabalha sozinho...', descricao: 'Prestador que trabalha sozinho, não precisa mais criar colaboradores. Com essa melhoria melhora a experiência do consumidor final e diminui o tempo para realizar um agendamento.' },
    { id: 7, titulo: 'Novidade',                subtitulo: '09-11-24: Acrescentamos a opção "Intervalo de Atendimentos"...', descricao: 'Anteriormente o intervalo de um atendimento para outro era de 60 em 60 minutos. Agora, o prestador pode mudar entre 30/30 minutos até no máximo 120/120 minutos (2 horas).' },
    { id: 6, titulo: 'Atualização no Layout',   subtitulo: '09-11-24: Retiramos a opção de "TipoAtendimento"...', descricao: 'Foi removida esta opção que estava dentro do menu "empresa" e movida para dentro do menu "Regras".' },
    { id: 5, titulo: 'Melhorias',               subtitulo: '09-11-24: Melhoramos a interface do usuário...', descricao: 'Criamos o novo menu "Regras", onde novas opções foram criadas: "dias/horários" e "feriados". Todas as novas configurações estarão dentro deste menu.' },
    { id: 4, titulo: 'Novidade',                subtitulo: '08-11-24: Link Personalizado...',       descricao: 'A partir desta atualização, se o prestador trabalhar sozinho, não é necessário ele se cadastrar como "Colaborador", pois o sistema mostrará para o cliente ambas as opções, sem que o cliente saiba.' },
    { id: 3, titulo: 'Correções',               subtitulo: '29-10-24: Link Personalizado...',       descricao: 'O [link personalizado] não estava sendo exibido na tela "Empresa" mesmo se ele já estivesse sido cadastrado. Falha corrigida.' },
    { id: 2, titulo: 'Atualização no Layout',   subtitulo: '29-10-24: Foto do colaborador...',      descricao: 'A partir de agora, toda vez que você passar o seu link personalizado de agendamento para seu cliente, além do nome do colaboraedor, ele também verá a foto dele.' },
    { id: 1, titulo: 'Atualização no Layout',   subtitulo: '28-10-24: Melhoramos a interface...',   descricao: 'A página/menu "Serviços" tanto para alterar quanto para incluir novo serviço, o layout se ajusta de acordo com o tamanho da tela do celular, tablet, PC, etc.' },
];


function Home() {
    // verifica se os tokens estão presentes e não corrompidos/vencidos
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenLG = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa);
    const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado);
    const [validado, setvalidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [tipoAtendimento] = useState(initialUserData.tipoAtendimento); // Usar setIdUsuario para atualizar o id_usuario
    const [agendaFechada, setAgendaFechada] = useState(initialUserData.agenda_fechada);  // 0 = Aberta, 1 = Fechada
    const [tipoAgenda, setTipoAgenda] = useState(initialUserData.tipoAgenda); // 0 = Global, 1 = Individual
    const [lock, setLock] = useState(initialUserData.bloqueio);  // 0 = prestador liberado, 1 = prestador bloqueado por fim de contrato // linha acima
    const [diasVencimentoContrato, setdiasVencimentoContrato] = useState(initialUserData.dias_FimContrato);  // receber a quantidade de dias que faltam pra encerrar o contrato 6/12/24w

    const [qtServicos, setQTServicos] = useState(0); // total de serviços cadastrados
    const [qtServicosAvulsos, setQTServicosAvulsos] = useState(0); // total de serviços cadastrados disponíveis pra agendamento avulso
    const navigate = useNavigate();

    // Função para definir cores por categoria
    const getCorCategoria = (categoria) => {
        const cores = {
            'Novidade': '#007bff',
            'Melhorias': '#28a745', 
            'Correções': '#dc3545',
            'Atualização no Layout': '#6f42c1',
            'Segurança': '#fd7e14'
        };
        return cores[categoria] || '#6c757d';
    };

    // Função para formatar a data (17-10-25 → 17/10/2025)
    const formatarData = (dataString) => {
        const [dia, mes, ano] = dataString.split('-');
        return `${dia}/${mes}/20${ano}`;
    };

    // monitora o sistema se não há falhas ou fraudes
    useEffect(() => {
        const executarVerificacoes = async () => {
            if (userId !== 0 && userId !== undefined) {

                // Verifica se o email está validado
                const emailValidadoOk = await VerificaEmailValidado(userId, emailValidado);
                if (!emailValidadoOk) return;  // Se não está validado, não continua
    
                // Verifica se a empresa está cadastrada
                const empresaCadastradaOk = await VerificaSeEmpresaCadastrada(userId, indEmpresa);
                if (!empresaCadastradaOk) return;  // Se não está cadastrada, não continua
    
                // Verifica se o CPF/CNPJ está validado
                const cpfCnpjValidadoOk = await VerificaSeCpfCnpjValidado(validado);
                if (!cpfCnpjValidadoOk) return;  // Se não está validado, não continua

                // Verifica se está vencendo pra renovar contrato ou contratar novo
                const faltaMenosCincoDiasOk = await VerificaDiasFaltaVencerContrato(diasVencimentoContrato);
                if (!faltaMenosCincoDiasOk) return;  // Se está bloqueada, não continua

                // Verifica se a empresa está bloqueada
                const empresaDesbloqueadaOk = await VerificaSeEmpresaBloqueada(lock);
                if (!empresaDesbloqueadaOk) return;  // Se está bloqueada, não continua

                // const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
                // // console.log('esconderNovidades ', esconderNovidades );
                // // if (!esconderNovidades) {
                // if (!esconderNovidades || novidades.length > 0) {
                //     setMostrarNovidades(true);
                // }

                const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
                const ultimaNovidadeVista = parseInt(localStorage.getItem(CHAVE_ULTIMA_NOVIDADE_VISTA) || '0');
                
                // Exibe novidades se:
                // 1. Não marcou "não exibir" OU
                // 2. Há novidades novas (ID maior que a última vista)
                const haNovidadesNovas = ULTIMA_NOVIDADE_ID > ultimaNovidadeVista;
                
                if ((!esconderNovidades && novidades.length > 0) || haNovidadesNovas) {
                    setMostrarNovidades(true);
                }                
            }
        };
    
        executarVerificacoes();
    }, [userId, emailValidado, indEmpresa, lock, validado]);

    const [mostrarNovidades, setMostrarNovidades] = useState(false);

    //***** bloco todo levado pra dentro do  */
    // // Verifica se deve exibir as novidades
    // useEffect(() => {
    //     const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
    //     if (!esconderNovidades || novidades.length > 0) {
    //         setMostrarNovidades(true);
    //     }
    // }, []);

    // // Função para exibir o modal de novidades
    // const exibirNovidades = () => {
    //     MySwal.fire({
    //     // MySwalNovidades.fire({
    //         title: 'Novidades da Aplicação',
    //         html: (
    //             <div>
    //                 <ul style={{ listStyleType: 'none', padding: 0 }}>
    //                     {novidades.map((novidade) => (
    //                         <li key={novidade.id} style={{ marginBottom: '20px' }}>
    //                             <strong>{novidade.titulo}</strong>
    //                             <p>{novidade.subtitulo}</p>
    //                             <button
    //                                 onClick={() => abrirDescricaoNovidade(novidade.descricao)}
    //                                 style={{ border: 'none', background: 'none', color: 'blue', cursor: 'pointer' }}
    //                             >
    //                                 Ver mais
    //                             </button>
    //                         </li>
    //                     ))}
    //                 </ul>
    //                 <div>
    //                     <input
    //                         type="checkbox"
    //                         id="naoExibirNovamente"
    //                         onChange={(e) => localStorage.setItem('esconderNovidades', e.target.checked)}
    //                     />
    //                     <label htmlFor="naoExibirNovamente" style={{ marginLeft: '5px' }}>
    //                         Não exibir da próxima vez, exceto se houver novidades
    //                     </label>
    //                 </div>
    //             </div>
    //         ),
    //         showCloseButton: true,
    //         showConfirmButton: false,
    //         width: '600px',
    //     });
    // };

    // // Função exibirNovidades atualizada
    // const exibirNovidades = () => {
    //     const ultimaNovidadeVista = parseInt(localStorage.getItem(CHAVE_ULTIMA_NOVIDADE_VISTA) || '0');
    //     const novidadesParaExibir = novidades.filter(novidade => 
    //         !localStorage.getItem('esconderNovidades') || novidade.id > ultimaNovidadeVista
    //     );

    //     if (novidadesParaExibir.length === 0) return;

    //     MySwal.fire({
    //         title: 'Novidades da Aplicação',
    //         html: (
    //             <div>
    //                 <div style={{ marginBottom: '15px', fontSize: '0.9rem', color: '#666' }}>
    //                     {ULTIMA_NOVIDADE_ID > ultimaNovidadeVista && (
    //                         <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
    //                             ⭐ {ULTIMA_NOVIDADE_ID - ultimaNovidadeVista} nova(s) novidade(s) desde sua última visita!
    //                         </span>
    //                     )}
    //                 </div>
                    
    //                 <ul style={{ listStyleType: 'none', padding: 0, maxHeight: '400px', overflowY: 'auto' }}>
    //                     {novidadesParaExibir.map((novidade) => (
    //                         <li key={novidade.id} style={{ 
    //                             marginBottom: '20px',
    //                             padding: '15px',
    //                             border: novidade.id > ultimaNovidadeVista ? '2px solid #007bff' : '1px solid #ddd',
    //                             borderRadius: '8px',
    //                             backgroundColor: novidade.id > ultimaNovidadeVista ? '#f8f9ff' : '#fff'
    //                         }}>
    //                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
    //                                 <div>
    //                                     <strong style={{ color: '#333' }}>{novidade.titulo}</strong>
    //                                     <p style={{ margin: '5px 0', color: '#666' }}>{novidade.subtitulo}</p>
    //                                 </div>
    //                                 {novidade.id > ultimaNovidadeVista && (
    //                                     <span style={{ 
    //                                         background: '#007bff', 
    //                                         color: 'white', 
    //                                         padding: '2px 8px', 
    //                                         borderRadius: '12px', 
    //                                         fontSize: '0.8rem',
    //                                         marginLeft: '10px'
    //                                     }}>
    //                                         NOVO
    //                                     </span>
    //                                 )}
    //                             </div>
    //                             <button
    //                                 onClick={() => abrirDescricaoNovidade(novidade.descricao)}
    //                                 style={{ 
    //                                     border: 'none', 
    //                                     background: 'none', 
    //                                     color: '#007bff', 
    //                                     cursor: 'pointer',
    //                                     fontSize: '0.9rem',
    //                                     padding: 0,
    //                                     marginTop: '5px'
    //                                 }}
    //                             >
    //                                 📖 Ver mais detalhes
    //                             </button>
    //                         </li>
    //                     ))}
    //                 </ul>
                    
    //                 <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
    //                     <div style={{ marginBottom: '10px' }}>
    //                         <input
    //                             type="checkbox"
    //                             id="naoExibirNovamente"
    //                             defaultChecked={localStorage.getItem('esconderNovidades') === 'true'}
    //                             onChange={(e) => {
    //                                 localStorage.setItem('esconderNovidades', e.target.checked);
    //                                 if (!e.target.checked) {
    //                                     // Se desmarcar, reseta para ver todas as novidades
    //                                     localStorage.removeItem(CHAVE_ULTIMA_NOVIDADE_VISTA);
    //                                 }
    //                             }}
    //                         />
    //                         <label htmlFor="naoExibirNovamente" style={{ marginLeft: '8px', fontSize: '0.9rem' }}>
    //                             Não exibir novidades já visualizadas
    //                         </label>
    //                     </div>
                        
    //                     <button
    //                         onClick={() => {
    //                             // Mostrar todas as novidades
    //                             localStorage.removeItem('esconderNovidades');
    //                             localStorage.removeItem(CHAVE_ULTIMA_NOVIDADE_VISTA);
    //                             MySwal.close();
    //                             setTimeout(() => setMostrarNovidades(true), 100);
    //                         }}
    //                         style={{
    //                             border: '1px solid #6c757d',
    //                             background: 'white',
    //                             color: '#6c757d',
    //                             padding: '5px 10px',
    //                             borderRadius: '4px',
    //                             fontSize: '0.8rem',
    //                             cursor: 'pointer'
    //                         }}
    //                     >
    //                         🔄 Mostrar todas as novidades
    //                     </button>
    //                 </div>
    //             </div>
    //         ),
    //         showCloseButton: true,
    //         showConfirmButton: false,
    //         width: '700px',
    //         didClose: () => {
    //             // Ao fechar, marca todas as novidades como vistas
    //             localStorage.setItem(CHAVE_ULTIMA_NOVIDADE_VISTA, ULTIMA_NOVIDADE_ID.toString());
    //         }
    //     });
    // };    

    // Função exibirNovidades atualizada - CORREÇÃO
    
    const exibirNovidades = () => {
        const esconderNovidades = localStorage.getItem('esconderNovidades') === 'true';
        const ultimaNovidadeVista = parseInt(localStorage.getItem(CHAVE_ULTIMA_NOVIDADE_VISTA) || '0');
        
        // Filtra as novidades para mostrar apenas as não vistas (se marcou a opção)
        const novidadesParaExibir = esconderNovidades 
            ? novidades.filter(novidade => novidade.id > ultimaNovidadeVista)
            : novidades;

        if (novidadesParaExibir.length === 0) return;

        MySwal.fire({
            title: 'Novidades da Aplicação',
            html: (
                <div>
                    <div style={{ marginBottom: '15px', fontSize: '0.9rem', color: '#666' }}>
                        {ULTIMA_NOVIDADE_ID > ultimaNovidadeVista && (
                            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                ⭐ {ULTIMA_NOVIDADE_ID - ultimaNovidadeVista} nova(s) novidade(s) desde sua última visita!
                            </span>
                        )}
                    </div>
                    
                    <ul style={{ listStyleType: 'none', padding: 0, maxHeight: '400px', overflowY: 'auto' }}>
                        
                        {/* {novidadesParaExibir.map((novidade) => (
                            <li key={novidade.id} style={{ 
                                marginBottom: '20px',
                                padding: '15px',
                                border: novidade.id > ultimaNovidadeVista ? '2px solid #007bff' : '1px solid #ddd',
                                borderRadius: '8px',
                                backgroundColor: novidade.id > ultimaNovidadeVista ? '#f8f9ff' : '#fff'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <div>
                                        <strong style={{ color: '#333' }}>{novidade.titulo}</strong>
                                        <p style={{ margin: '5px 0', color: '#666' }}>{novidade.subtitulo}</p>
                                    </div>
                                    {novidade.id > ultimaNovidadeVista && (
                                        <span style={{ 
                                            background: '#007bff', 
                                            color: 'white', 
                                            padding: '2px 8px', 
                                            borderRadius: '12px', 
                                            fontSize: '0.8rem',
                                            marginLeft: '10px'
                                        }}>
                                            NOVO
                                        </span>
                                    )}
                                </div>
                                <button
                                    onClick={() => abrirDescricaoNovidade(novidade.descricao)}
                                    style={{ 
                                        border: 'none', 
                                        background: 'none', 
                                        color: '#007bff', 
                                        cursor: 'pointer',
                                        fontSize: '0.9rem',
                                        padding: 0,
                                        marginTop: '5px'
                                    }}
                                >
                                    📖 Ver mais detalhes
                                </button>
                            </li>
                        ))} */}

                        {/* // No componente de exibição das novidades, substitua a parte do item: */}
                        {novidadesParaExibir.map((novidade) => {
                            // Extrai a data do subtítulo (assumindo formato "DD-MM-AA: texto")
                            const match = novidade.subtitulo.match(/^(\d{2}-\d{2}-\d{2}):\s*(.*)/);
                            const data = match ? match[1] : null;
                            const subtituloLimpo = match ? match[2] : novidade.subtitulo;
                            
                            return (
                                <li key={novidade.id} style={{ 
                                    marginBottom: '20px',
                                    padding: '15px',
                                    border: novidade.id > ultimaNovidadeVista ? '2px solid #007bff' : '1px solid #e9ecef',
                                    borderRadius: '10px',
                                    backgroundColor: novidade.id > ultimaNovidadeVista ? '#f8f9ff' : '#fafafa',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                        <div style={{ flex: 1 }}>
                                            {/* Cabeçalho com categoria e data */}
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', flexWrap: 'wrap' }}>
                                                <span style={{
                                                    background: getCorCategoria(novidade.titulo),
                                                    color: 'white',
                                                    padding: '2px 8px',
                                                    borderRadius: '12px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 'bold',
                                                    marginRight: '8px'
                                                }}>
                                                    {novidade.titulo}
                                                </span>
                                                
                                                {data && (
                                                    <span style={{
                                                        color: '#6c757d',
                                                        fontSize: '0.8rem',
                                                        fontWeight: '500'
                                                    }}>
                                                        📅 {formatarData(data)}
                                                    </span>
                                                )}
                                            </div>
                                            
                                            {/* Subtítulo */}
                                            <p style={{ 
                                                margin: '0', 
                                                color: '#495057',
                                                fontSize: '0.95rem',
                                                lineHeight: '1.4'
                                            }}>
                                                {subtituloLimpo}
                                            </p>
                                        </div>
                                        
                                        {/* Badge NOVO */}
                                        {novidade.id > ultimaNovidadeVista && (
                                            <span style={{ 
                                                background: 'linear-gradient(135deg, #007bff, #0056b3)', 
                                                color: 'white', 
                                                padding: '3px 10px', 
                                                borderRadius: '15px', 
                                                fontSize: '0.7rem',
                                                fontWeight: 'bold',
                                                marginLeft: '10px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                NOVO
                                            </span>
                                        )}
                                    </div>
                                    
                                    {/* Botão Ver mais */}
                                    {/* <button
                                        onClick={() => abrirDescricaoNovidade(novidade.descricao)}
                                        style={{ 
                                            border: 'none', 
                                            background: 'none', 
                                            color: '#007bff', 
                                            cursor: 'pointer',
                                            fontSize: '0.85rem',
                                            padding: '5px 0',
                                            marginTop: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontWeight: '500'
                                        }}
                                    >
                                        📖 Ver detalhes completos
                                        <i className="bi bi-chevron-right" style={{ marginLeft: '5px', fontSize: '0.8rem' }}></i>
                                    </button> */}

                                    <button
                                        onClick={() => abrirDescricaoNovidade(novidade.descricao, novidade.id)}
                                        style={{ 
                                            border: 'none', 
                                            background: 'none', 
                                            color: '#007bff', 
                                            cursor: 'pointer',
                                            fontSize: '0.85rem',
                                            padding: '5px 0',
                                            marginTop: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontWeight: '500'
                                        }}
                                    >
                                        📖 Ver detalhes completos
                                        <i className="bi bi-chevron-right" style={{ marginLeft: '5px', fontSize: '0.8rem' }}></i>
                                    </button>
                                </li>
                            );
                        })}

                    </ul>
                    
                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <input
                                type="checkbox"
                                id="naoExibirNovamente"
                                defaultChecked={esconderNovidades}
                                onChange={(e) => {
                                    localStorage.setItem('esconderNovidades', e.target.checked);
                                    if (!e.target.checked) {
                                        // Se desmarcar, reseta para ver todas as novidades
                                        localStorage.removeItem(CHAVE_ULTIMA_NOVIDADE_VISTA);
                                    }
                                }}
                            />
                            <label htmlFor="naoExibirNovamente" style={{ marginLeft: '8px', fontSize: '0.9rem' }}>
                                Não exibir novidades já visualizadas
                            </label>
                        </div>
                        
                        <button
                            onClick={() => {
                                // Marcar TODAS como lidas agora
                                localStorage.setItem(CHAVE_ULTIMA_NOVIDADE_VISTA, ULTIMA_NOVIDADE_ID.toString());
                                MySwal.close();
                            }}
                            style={{
                                border: '1px solid #28a745',
                                background: '#28a745',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '4px',
                                fontSize: '0.8rem',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            ✅ Marcar todas como lidas
                        </button>

                        <button
                            onClick={() => {
                                // Mostrar todas as novidades
                                localStorage.removeItem('esconderNovidades');
                                localStorage.removeItem(CHAVE_ULTIMA_NOVIDADE_VISTA);
                                MySwal.close();
                                setTimeout(() => setMostrarNovidades(true), 100);
                            }}
                            style={{
                                border: '1px solid #6c757d',
                                background: 'white',
                                color: '#6c757d',
                                padding: '5px 10px',
                                borderRadius: '4px',
                                fontSize: '0.8rem',
                                cursor: 'pointer'
                            }}
                        >
                            🔄 Mostrar todas as novidades
                        </button>
                    </div>
                </div>
            ),
            showCloseButton: true,
            showConfirmButton: false,
            width: '700px',
            didClose: () => {
                // Ao fechar, marca apenas as novidades EXIBIDAS como vistas
                if (novidadesParaExibir.length > 0) {
                    const maiorIdExibido = Math.max(...novidadesParaExibir.map(n => n.id));
                    localStorage.setItem(CHAVE_ULTIMA_NOVIDADE_VISTA, maiorIdExibido.toString());
                }
            }
        });
    };

    // Exibe a descrição completa da novidade ao clicar
    // const abrirDescricaoNovidade = (descricao) => {
    //     MySwal.fire({
    //     // MySwalNovidades.fire({
    //         title: 'Descrição da Novidade',
    //         text: descricao,
    //         icon: 'info',
    //         confirmButtonText: 'Fechar',
    //     });
    // };

    const abrirDescricaoNovidade = (descricao, novidadeId) => {
        // Marca ESTA novidade específica como lida
        const ultimaNovidadeVistaAtual = parseInt(localStorage.getItem(CHAVE_ULTIMA_NOVIDADE_VISTA) || '0');
        
        // Se esta novidade for mais recente que a última vista, atualiza
        if (novidadeId > ultimaNovidadeVistaAtual) {
            localStorage.setItem(CHAVE_ULTIMA_NOVIDADE_VISTA, novidadeId.toString());
        }
        
        // Sua lógica original para mostrar os detalhes
        MySwal.fire({
            title: 'Detalhes da Novidade',
            html: `<div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
                    <p>${descricao}</p>
                </div>`,
            confirmButtonText: 'Fechar',
            width: '600px'
        });
    };

    // // Exibe as novidades se necessário
    // useEffect(() => {
    //     if (mostrarNovidades) {
    //         exibirNovidades();
    //     }
    // }, [mostrarNovidades]);

    // useEffect para exibir novidades

    useEffect(() => {
        if (mostrarNovidades) {
            exibirNovidades();
            setMostrarNovidades(false); // Reseta após exibir
        }
    }, [mostrarNovidades]);
    
    // Função para verificar se o email está validado
    const VerificaEmailValidado = async (userId, emailValidado) => {
        // if (emailValidado === 0) {
        if (emailValidado !== 1) {
            const result = await Swal.fire({
                title: 'Ativação da Conta',
                text: 'Para cadastrar sua empresa no AgendeX, você precisa validar seu email. Deseja validá-lo agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, validar!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                carregaDados(userId); // Função para carregar dados e validar email
                return false; // Para o fluxo até a validação ser concluída
            } else {
                AutoLogout();
                return false; // Impede continuação
            }
        }
        return true; // Email validado, pode continuar
    };
    
    // Função para verificar se a empresa está cadastrada
    const VerificaSeEmpresaCadastrada = async (userId, indEmpresa) => {
        // if (indEmpresa === 0 || indEmpresa === null || indEmpresa === undefined) {
        if (indEmpresa !== 1) {
            const result = await Swal.fire({
                title: 'Cadastro Incompleto',
                text: 'Para continuar, você precisa completar os dados do seu Negócio/Empresa. Deseja continuar o cadastro agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, cadastrar!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
    
            if (result.isConfirmed) {
                if (userId) {
                    navigate('/app/prestador/perfil/cadastrarempresa', { 
                        state: { iduser: userId, indEmpresa: indEmpresa, from: '/app/prestador/home/' } 
                    });
                } else {
                    console.error("userId não definido");
                }
                return false; // Para impedir continuação
            } else {
                AutoLogout();
                return false; // Para impedir continuação
            }
        }
        return true; // Empresa cadastrada, pode continuar
    };
    
    // Função para verificar se a empresa está bloqueada
    const VerificaSeEmpresaBloqueada = async (lock) => {
        if (lock !== 0) {
            const result = await Swal.fire({
                title: 'Cadastro Bloqueado',
                text: 'Para desbloquear sua conta, entre em contato com o Suporte Agendex. Deseja fazer logout agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, fazer logout!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                // localStorage.clear(); // modificada pela linha abaixo 30/12/24w
                localStorage.removeItem("tokenlg");
                localStorage.removeItem("tokenapw");
                localStorage.removeItem("tokenasw");
           
                navigate('/');
            } else {
                AutoLogout();
            }
            return false; // Empresa bloqueada, impede continuação
        }
        return true; // Empresa desbloqueada, pode continuar
    };
    
    // Função para verificar se o CPF/CNPJ está validado
    const VerificaSeCpfCnpjValidado = async (validado) => {
        if (validado !== 1) {
            const result = await Swal.fire({
                title: 'Cadastro em Validação',
                text: 'Estamos agilizando a validação do seu cadastro. Deseja fazer logout agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, fazer logout!',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                // localStorage.clear(); // modificada pelas linhas abaixo 30/12/24w
                localStorage.removeItem("tokenlg");
                localStorage.removeItem("tokenapw");
                localStorage.removeItem("tokenasw");

                navigate('/');
            } else {
                AutoLogout();
            }
            return false; // CPF/CNPJ não validado, impede continuação
        }
        return true; // CPF/CNPJ validado, pode continuar
    };

    // Função para verificar quantos dias que faltam pra encerrar o contrato
    const VerificaDiasFaltaVencerContrato = async (dias) => {
        if (dias <= 5 && dias >=1 ) {
            const result = await Swal.fire({
                title: 'Contrato Finalizando',
                text: 'Faltam ' + dias + ' para o fim do seu contrato. Deseja entrar em contato com o suporte agora?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, fazer logout!',
                cancelButtonText: 'Agora não!',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            if (result.isConfirmed) {
                // localStorage.clear(); // substituída pelas linhas abaixo 30/12/24w
                localStorage.removeItem("tokenlg");
                localStorage.removeItem("tokenapw");
                localStorage.removeItem("tokenasw");

                navigate('/');
            } else {
                // AutoLogout();
                return true; // pode continuar
            }
            return false; // impede continuação
        }
        return true; // pode continuar
    };

    const { loading, setLoading, MySwal, carregaDados, carregaTotalServicos } = useCarregaDados();

    useEffect(() => {
        if (userId) {
            carregaTotalServicos(userId, setQTServicos, setQTServicosAvulsos);
        }
    }, [userId]);

    const toggleAgendaStatus = async () => {
        const novoStatus = agendaFechada === 0 ? 1 : 0;
        setAgendaFechada(novoStatus);
        setLoading(true);
        try {
            // console.log(tokenASW);
            const response = await apiaxios.put('Usuario/AgendaFechadaWeb', {
                id_usuario: userId,
                // token: tokenASW,
                agenda_fechada: novoStatus
            }, {params: {id_usuario: userId, token: tokenASW}});
    
            if (response.status === 200 && response.data.retorno === 'OK') {
                // MySwal.fire('Status da Agenda', '"Status da Agenda" mudado com sucesso!', 'info');
                const mensagemStatus = novoStatus === 0 
                    ? '"Status da Agenda" mudado para "Aberta" com sucesso!' 
                    : '"Status da Agenda" mudado para "Fechada" com sucesso!';

                MySwal.fire('Status da Agenda', mensagemStatus, 'info');
                
                const encryptedToken = localStorage.getItem('tokenapw');
                const token = decrypt(encryptedToken);
                token.agenda_fechada = novoStatus;
                const updatedEncryptedToken = encrypt(token);
                localStorage.setItem('tokenapw', updatedEncryptedToken);
            } else {
                throw new Error(response.data.retorno || 'Falha ao carregar seus dados.');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
    
    // Função para alternar o tipo de agenda
    const toggleTipoAgenda = async () => {
        Swal.fire('Tipo de Agenda', 'Opção indisponível na Web. Para modificar, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    };

    // Função para fazer agendamento avulso
    const toggleAgendaAvulso = async () => {
        Swal.fire('Agendamento Avulso', 'Opção indisponível na Web. Para realizar um agendamento avulso, baixe o App "Agendex Prestador" na "Google Play Store"', 'info');
    };

    // Função para alternar o tipo de atendimento
    const toggleTipoAtendimento = async () => {
        Swal.fire('Tipo de Atendimento', 'Tome muito cuidado ao mudar esta opção que deve ser alterada no menu "Regras de Atendimento". Nela você informa se trabalha sozinho(a) ou com funcionário(s).', 'info');
    };

    const toggleServicos = async () => {
        navigate('/app/prestador/empresa/servicos');
    };
    


    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page='home' />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="text-center">
                                <h1>Home</h1>
                            </div>
                            <hr />

                            <MenuConfig id_usuario={userId} page="home"/>
                            <div className="container-fluid">
                                <Container>
                                    {/* Status da Agenda */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Status da Agenda</h4>
                                        <Button
                                            variant={agendaFechada === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            onClick={toggleAgendaStatus}
                                        >
                                            Aberta
                                        </Button>
                                        <Button
                                            variant={agendaFechada === 1 ? 'success' : 'secondary'}
                                            onClick={toggleAgendaStatus}
                                        >
                                            Fechada
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr />

                                    {/* Tipo de Agenda */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <h4>Tipo de Agenda</h4>
                                        <Button
                                            variant={tipoAgenda === 0 ? 'success' : 'secondary'}
                                            className="me-2"
                                            onClick={toggleTipoAgenda}
                                        >
                                            Global
                                        </Button>
                                        <Button
                                            variant={tipoAgenda === 1 ? 'success' : 'secondary'}
                                            onClick={toggleTipoAgenda}
                                        >
                                            Individual
                                        </Button>
                                        </Col>
                                    </Row>
                                    <hr />

                                    {/* Tipo de Atendimento */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                            <h4>Tipo de Atendimento</h4>
                                            <Button
                                                variant={tipoAtendimento === 1 ? 'success' : 'secondary'}
                                                // variant='success'
                                                className="me-2"
                                                onClick={toggleTipoAtendimento}
                                            >
                                                {tipoAtendimento === 0 ? 'Sem Colaborador' : 'Com Colaborador(es)'}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <hr />                                    

                                    {/* Botão "Serviços a Oferecer" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className="btn-lg"
                                            onClick={toggleServicos}
                                        >
                                            
                                            <div><h1>Serviços a Oferecer</h1></div>
                                            <div>{qtServicos} Cadastrados</div> {/* Esse valor xx será atualizado dinamicamente depois */}
                                        </Button>
                                        </Col>
                                    </Row>
                                    
                                    {/* Botão "Agendar Serviço Avulso" */}
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg"
                                            onClick={toggleAgendaAvulso}
                                        >
                                            <div><h1>Agendar Serviço Avulso</h1></div>
                                            <div>{qtServicosAvulsos} Serviços disponíveis</div> {/* Esse valor xx será atualizado dinamicamente depois */}
                                        </Button>
                                        </Col>
                                    </Row>

                                    {/* Botão "Agendamentos"
                                    <Row className="mt-3 text-center">
                                        <Col>
                                        <Button variant="success" className=" btn-lg">
                                            <div><h1>Agendamentos</h1></div>
                                            <div>xx Cadastrados</div> {/* Esse valor xx será atualizado dinamicamente depois //}
                                        </Button>
                                        </Col>
                                    </Row> */}
                                    
                                </Container>          
                                <div className="row">
                                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Home;